// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js!../shared.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quiz-settings-run {
  background-color: var(--white);
  box-shadow: var(--shadow);
  display: flex;
  cursor: pointer;
	color: inherit;
	border: none;
	padding: 0;
	font: inherit;
	outline: inherit;
  width: 100%;
}

.quiz-settings-run :hover {
    background-color: var(--grey1);
  }

.quiz-settings-run > * {
    padding: 0.5rem 1rem;
  }

.quiz-settings-run .timestamp {
    width: 85%;
    text-align: left;
  }

.quiz-settings-run #quiz-results {
    width: 15%;
    display: inline-flex;
    flex-wrap: wrap;
    justify-content: center;
  }

.quiz-settings-run .quiz-result-absolute {
    margin-right: 0.5rem;
  }

.quiz-settings-runs-header {
  display: flex;
  justify-content: space-between;
}

.quiz-settings-runs-title {
  font-size: 0.8rem;
  padding: 0.5rem;
  color: var(--header-color);
  margin: 0;
  background-color: var(--header-bg-color);
}


@media (max-width: 48rem) {

  .quiz-settings-run .timestamp {
    width: 80%;
  }

  .quiz-settings-run #quiz-results {
    width: 20%;
    padding: 0.5rem;
    font-size: 0.8rem;
  }

  .quiz-settings-run .quiz-result-absolute {
    margin-right: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./core/components/quizzes/QuizRun.css"],"names":[],"mappings":"AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,aAAa;EACb,eAAe;CAChB,cAAc;CACd,YAAY;CACZ,UAAU;CACV,aAAa;CACb,gBAAgB;EACf,WAAW;AA0Bb;;AAvBE;IACE,8BAA8B;EAChC;;AAEA;IACE,oBAAoB;EACtB;;AAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;AAEA;IACE,UAAU;IACV,oBAAoB;IACpB,eAAe;IACf,uBAAuB;EACzB;;AAEA;IACE,oBAAoB;EACtB;;AAGF;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,0BAA0B;EAC1B,SAAS;EACT,wCAAwC;AAC1C;;;AAGA;;EAEE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["@import \"../shared.css\";\r\n\r\n.quiz-settings-run {\r\n  background-color: var(--white);\r\n  box-shadow: var(--shadow);\r\n  display: flex;\r\n  cursor: pointer;\r\n\tcolor: inherit;\r\n\tborder: none;\r\n\tpadding: 0;\r\n\tfont: inherit;\r\n\toutline: inherit;\r\n  width: 100%;\r\n\r\n\r\n  & :hover {\r\n    background-color: var(--grey1);\r\n  }\r\n\r\n  & > * {\r\n    padding: 0.5rem 1rem;\r\n  }\r\n\r\n  & .timestamp {\r\n    width: 85%;\r\n    text-align: left;\r\n  }\r\n\r\n  & #quiz-results {\r\n    width: 15%;\r\n    display: inline-flex;\r\n    flex-wrap: wrap;\r\n    justify-content: center;\r\n  }\r\n\r\n  & .quiz-result-absolute {\r\n    margin-right: 0.5rem;\r\n  }\r\n}\r\n\r\n.quiz-settings-runs-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.quiz-settings-runs-title {\r\n  font-size: 0.8rem;\r\n  padding: 0.5rem;\r\n  color: var(--header-color);\r\n  margin: 0;\r\n  background-color: var(--header-bg-color);\r\n}\r\n\r\n\r\n@media (max-width: 48rem) {\r\n\r\n  .quiz-settings-run .timestamp {\r\n    width: 80%;\r\n  }\r\n\r\n  .quiz-settings-run #quiz-results {\r\n    width: 20%;\r\n    padding: 0.5rem;\r\n    font-size: 0.8rem;\r\n  }\r\n\r\n  .quiz-settings-run .quiz-result-absolute {\r\n    margin-right: 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
